export const propToCSSMap: Record<string, string> = {
  boxSizing: 'box-sizing',
  display: 'display',
  direction: 'flex-direction',
  grow: 'flex-grow',
  shrink: 'flex-shrink',
  wrap: 'flex-wrap',
  justifyContent: 'justify-content',
  justifyItems: 'justify-items',
  justifySelf: 'justify-self',
  alignContent: 'align-content',
  alignItems: 'align-items',
  alignSelf: 'align-self',
  bg: 'background-color',
  borderRadius: 'border-radius',
  margin: 'margin',
  marginVertical: 'margin-top margin-bottom',
  marginHorizontal: 'margin-left margin-right',
  marginTop: 'margin-top',
  marginRight: 'margin-right',
  marginBottom: 'margin-bottom',
  marginLeft: 'margin-left',
  padding: 'padding',
  paddingVertical: 'padding-top padding-bottom',
  paddingHorizontal: 'padding-left padding-right',
  paddingTop: 'padding-top',
  paddingRight: 'padding-right',
  paddingBottom: 'padding-bottom',
  paddingLeft: 'padding-left',
  fontFamily: 'font-family',
  fontSize: 'font-size',
  variant: 'font-size',
  fontWeight: 'font-weight',
  subStyle: 'font-weight',
  lineHeight: 'line-height',
  letterSpacing: 'letter-spacing',
  align: 'text-align',
  textDecoration: 'text-decoration',
  textDecorationColor: 'text-decoration-color',
  textUnderlineOffset: 'text-underline-offset',
}
